module.exports = __webpack_public_path__ + "img/西部ca授权.d016a174.jpg";